import React, { useEffect, useState } from "react";
import {
    Modal,
    DatePicker,
    message,
    Spin,
    Descriptions,
    Tag,
    Typography,
    Col,
    Row,
    Empty,
    Select
} from "antd";
import { addCampOffAttendance, fetchCampOffAttendance, getallDeveloperForTask } from "../../utils/API";
import dayjs from "dayjs";

const { Title } = Typography;

interface EditCustomersModalProps {
    visible: boolean;
    onClose?: () => void;
    onSuccess?: () => void;
}
interface CampassoffPage {
    _id: string;
    key: string;
    userId: string | { _id: string; username: string };
    username?: string;
    date: string;
    day: string;
    clockIn: string;
    lunchStart: string;
    lunchEnd?: string;
    endTime?: string;
    requestStatus?: string;
    lunchComplete: string;
    clockOut: string;
    totalTime: string;
    highlightRed?: boolean;
    status: 'Present' | 'Absent' | 'Late' | 'On Leave' | 'CampOff'; // Add 'CampOff' here
    attendanceId: string; // <-- Add this line
}
const AddCampassoffModal: React.FC<EditCustomersModalProps> = ({
    visible,
    onClose,
    onSuccess,
}) => {
    const [page, setPage] = useState(1);
    const [selectedDate, setSelectedDate] = useState<any | null>(null);
    const [attendanceData, setAttendanceData] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [loadingDevelopers, setLoadingDevelopers] = useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const authData = localStorage.getItem("authData");
    const [selectedDeveloper, setSelectedDeveloper] = useState<string | null>(null);
    const parsedAuthData = authData ? JSON.parse(authData) : "";
    const isAdmin = parsedAuthData?.roleId?.roleId === 1;
    const [developers, setDevelopers] = useState<CampassoffPage[]>([]);


    const handleDateChange = (date: dayjs.Dayjs | null) => {
        setSelectedDate(date);
        setAttendanceData(null);
        if (date) fetchAttendance(date);
    };

    useEffect(() => {
        const userId =
            isAdmin && selectedDeveloper
                ? selectedDeveloper
                : parsedAuthData?.user?._id;

        if (userId && selectedDate) {
            fetchCampOffAttendance(userId, selectedDate);
        }

        if (authData) {
            fetchDevelopers();
        }
    }, [authData, selectedDeveloper, page, selectedDate]);


    const fetchDevelopers = async () => {
        try {
            setLoadingDevelopers(true);
            const result = await getallDeveloperForTask("", "");
            if (result?.data) {
                setDevelopers(result.data);
            } else {
                message.warning("No developers found");
                setDevelopers([]);
            }
        } catch (error) {
            console.error("Error fetching developers:", error);
            message.error("Failed to fetch developers");
            setDevelopers([]);
        } finally {
            setLoadingDevelopers(false);
        }
    };
    const handleApply = async () => {
        if (!attendanceData || !selectedDate) return;

        // Get the current user's ID from auth data
        const currentUserId = authData ? JSON.parse(authData).user._id : null;
        if (!currentUserId) {
            message.error("User ID not found.");
            return;
        }

        setIsLoading(true);
        try {
            const payload = {
                userId: isAdmin && selectedDeveloper ? selectedDeveloper : currentUserId,
                requestedBy: currentUserId,
                date: selectedDate.format("DD/MM/YYYY"),
                clockIn: attendanceData.clockIn,
                clockOut: attendanceData.clockOut,
                lunchStart: attendanceData.lunchStart,
                lunchEnd: attendanceData.lunchEnd,
                status: attendanceData.status,
                reason: "",
                originalStatus: attendanceData.status,
                isAdminRequest: isAdmin
            };


            const res = await addCampOffAttendance(payload);
            if (res.success) {
                message.success("Camp-off attendance applied successfully!");
                onClose?.();
                onSuccess?.();
            } else {
                message.error(res.message || "Failed to apply camp-off attendance.");
            }
        } catch (error) {
            console.error("API Error:", error);
            message.error("An error occurred while applying attendance.");
        } finally {
            setIsLoading(false);
        }
    };


    const fetchAttendance = async (date: dayjs.Dayjs) => {
        // Use selectedDeveloper if admin, otherwise use logged-in user's ID
        const userId = isAdmin && selectedDeveloper
            ? selectedDeveloper
            : authData ? JSON.parse(authData).user._id : null;

        setLoading(true);
        try {
            const data = await fetchCampOffAttendance(userId, date);
            if (data.success) {
                message.success("Attendance data fetched successfully.");
                setAttendanceData(data.attendance);
            } else {
                message.warning("No attendance data found.");
            }
        } catch (err) {
            console.error("Failed to fetch attendance:", err);
            message.error("Error fetching attendance data.");
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status: string) => {
        switch (status) {
            case "Present":
                return "green";
            case "Absent":
                return "red";
            case "Camp Off":
                return "blue";
            default:
                return "default";
        }
    };

    return (
        <Modal

            visible={visible}
            onCancel={onClose}
            footer={null}
            width={500}
            centered={false}
            destroyOnClose
            className="custom-modal"
            style={{
                bottom: 20,
                top: 20,
                maxHeight: 'calc(100vh - 3  0px)',
                margin: '0 auto',
                position: 'relative',
            }}
            title={
                <div
                    style={{
                        color: "#4b5563",
                        fontFamily: "inter, sans-serif",
                        fontSize: "20px",
                        fontWeight: 500,
                    }}
                >
                    Add CampusOff
                </div>
            }
            bodyStyle={{
                overflowY: "auto",
                fontFamily: "inter, sans-serif",
            }}
            styles={{
                header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                },
                content: {
                    padding: 0,
                    overflow: "hidden",
                },
            }}
        >
            <div >
                <div className="p-3">
                    <DatePicker
                        onChange={handleDateChange}
                        style={{ width: "100%", marginBottom: 12 }}
                        format="DD/MM/YYYY"
                        placeholder="Select Date"

                    />
                </div>
                <div className="p-1.5">
                    <Col xs={24} md={24}>
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
                            {parsedAuthData?.roleId?.roleId === 1 && (
                                <Select
                                    showSearch
                                    style={{ width: '100%', marginLeft: "0vw" }}
                                    placeholder="Select developer"
                                    value={selectedDeveloper}
                                    onChange={(value: string) => {
                                        setSelectedDeveloper(value || null);
                                        setPage(1);
                                    }}
                                    allowClear
                                    onClear={() => {
                                        setSelectedDeveloper(null);
                                        setPage(1);
                                    }}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.children?.toString()?.toLowerCase() || '').includes(input.toLowerCase())
                                    }
                                >
                                    {developers.map(dev => (
                                        <Select.Option key={dev._id} value={dev._id}>
                                            {dev.username}
                                        </Select.Option>
                                    ))}
                                </Select>
                            )}
                        </div>
                    </Col>
                </div>
                {loading ? (
                    <Spin style={{ display: "flex", justifyContent: "center" }} />
                ) : attendanceData ? (
                    <>
                        <div className="p-3">
                            <Descriptions column={1} bordered size="middle">
                                <Descriptions.Item label="Date">
                                    {dayjs(attendanceData.date).format("DD/MM/YYYY")}
                                </Descriptions.Item>
                                <Descriptions.Item label="Clock In">
                                    {attendanceData.clockIn || "-"}
                                </Descriptions.Item>
                                <Descriptions.Item label="Clock Out">
                                    {attendanceData.clockOut || "-"}
                                </Descriptions.Item>
                                <Descriptions.Item label="Lunch Start">
                                    {attendanceData.lunchStart || "-"}
                                </Descriptions.Item>
                                <Descriptions.Item label="Lunch End">
                                    {attendanceData.lunchEnd || "-"}
                                </Descriptions.Item>
                                <Descriptions.Item label="Total Time">
                                    {attendanceData.endTime || "-"}
                                </Descriptions.Item>
                                <Descriptions.Item label="Status">
                                    <Tag color={getStatusColor(attendanceData.status)}>
                                        {attendanceData.status}
                                    </Tag>
                                </Descriptions.Item>
                            </Descriptions>

                        </div>





                    </>
                ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Data" style={{ height: "21vw", paddingTop: "5vw" }} />

                )}

                {/* Submit Button */}
                <Row justify="end">
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        xl={24}
                        xxl={20}
                        className="d-flex justify-content-end me-3"
                    >
                        <div className="button-wrapper">
                            <button
                                className="allcanclebutton"
                                onClick={onClose}
                                disabled={isLoading}
                            >
                                Cancel
                            </button>

                            <button className="allsubmitebutton w-52"
                                onClick={handleApply}  // Add this
                                disabled={isLoading || !attendanceData} // Also disable if no attendance data
                            >
                                {isLoading ? "Applying..." : "Apply"}
                            </button>
                        </div>
                    </Col>
                </Row>
            </div>

        </Modal>
    );
};

export default AddCampassoffModal;
